/**
 * @generated SignedSource<<bfbdc003b8bd801980da0cba60a88a8e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useShippingPriceV2_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"shippingHelpers_viewer">;
  readonly " $fragmentType": "useShippingPriceV2_viewer";
};
export type useShippingPriceV2_viewer$key = {
  readonly " $data"?: useShippingPriceV2_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"useShippingPriceV2_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useShippingPriceV2_viewer",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "shippingHelpers_viewer",
      "selections": [
        {
          "condition": "fetchRegionalInfo",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": "regionsInfo",
              "args": [
                {
                  "kind": "Variable",
                  "name": "countryCode",
                  "variableName": "userCountryCode"
                },
                {
                  "kind": "Variable",
                  "name": "zipCode",
                  "variableName": "userZipCode"
                }
              ],
              "concreteType": "RegionalInfo",
              "kind": "LinkedField",
              "name": "regionalInfo",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RegionsByZipCode",
                  "kind": "LinkedField",
                  "name": "regionsByZipCode",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "displayName",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ]
        }
      ],
      "args": null,
      "argumentDefinitions": [
        {
          "defaultValue": false,
          "kind": "LocalArgument",
          "name": "fetchRegionalInfo"
        },
        {
          "defaultValue": "",
          "kind": "LocalArgument",
          "name": "userCountryCode"
        },
        {
          "defaultValue": "",
          "kind": "LocalArgument",
          "name": "userZipCode"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "2eaaace1c007676df39b9a3e09c9baed";

export default node;
